import React from 'react';
import { DemoEnvironmentsList } from './DemoEnvironmentsList';
import { isDemoAgencySetupPanelEnabled } from './demoAgencySetupUi';

/**
 * The Demo Sandboxes tab.
 *
 * Thin on purpose: the non-prod gate lives here, and the list owns everything
 * else. This used to be a 673-line form whose results were
 * lost on reload.
 */
export const DemoEnvironmentsPanel: React.FC = () => {
  // Absent in production, not merely unreachable — same gate as before.
  if (!isDemoAgencySetupPanelEnabled()) {
    return null;
  }

  return (
    <section>
      <DemoEnvironmentsList />
    </section>
  );
};

export default DemoEnvironmentsPanel;
